export const environment = {
  // production: false, // UAT
  production: false,
  url: {
    // apiIntranetLogin:
    //   'https://intranet.ldd.go.th/api_service/officer_service.php/login',
    // apiIntranetLogout:
    //   'https://intranet.ldd.go.th/api_service/officer_service.php/logout',
    // apiIntranet: 'https://intranet.ldd.go.th/officer_login.php',
    // apiCheckToken:
    //   'https://intranet.ldd.go.th/api_service/officer_service.php/check_token',

    // lddApiUrl: 'https://ldd-user-service.adevsolutionsplus.com', // UAT
    // lddMasterApiUrl: 'https://ldd-master-service.adevsolutionsplus.com', // UAT
    // lddServiceApiUrl: 'https://uat-ldd-scanner.adevsolutionsplus.com', // UAT

    lddApiUrl: 'https://dev-ldd-scanner-service.adevsolutionsplus.com', // dev
    lddMasterApiUrl: 'https://dev-ldd-master.adevsolutionsplus.com', // dev
    lddServiceApiUrl: 'https://dev-ldd-scanner-service.adevsolutionsplus.com', // dev

    authenticationUrl: '/Authentication/Login',
    authenticationLogoutUrl: '/Authentication/Logout',
    material: {
      getAllListByTypeUrl: '/Material/GetAllByType',
      getAllListUrl: '/Material/List',
      getAllUnitUrl: '/Material/GetAllUnit',

      getTypeListUrl: '/Material/TypeList',
      getTypeListById: '/Material/TypeListById',
      getTypeByIDUrl: '/Material/TypeGet',
      createNewTypeUrl: '/Material/TypeSubmit',
      updateTypeByIdUrl: '/Material/TypeUpdate',
      updateTypeStatus: '/Material/TypeStatus',
      deleteTypeByIDUrl: '/Material/TypeDelete',
      typeCheckExist: '/Material/TypeCheckExist',

      getMainTypeListUrl: '/Material/MainTypeList',
      getMainTypeByIDUrl: '/Material/MainTypeGet',
      updateMainTypeStatus: '/Material/MainTypeStatus',
      updateSeparateType: '/Material/MainTypeUpdate',
      checkMainCodeExist: '/Material/MainTypeCheckExist',

      getGroupListUrl: '/Material/GroupList',
      getMultiGroupList: '/Material/MultiGroupList',
      getGroupByIDUrl: '/Material/GroupGet',
      createNewGroupUrl: '/Material/GroupSubmit',
      updateGroupByIdUrl: '/Material/GroupUpdate',
      updateGroupStatus: '/Material/GroupStatus',
      deleteGroupByIDUrl: '/Material/GroupDelete',
      groupCheckExist: '/Material/GroupCheckExist',

      getCategoryListUrl: '/Material/KindList',
      getCategoryByIDUrl: '/Material/KindGet',
      createNewCategoryUrl: '/Material/KindSubmit',
      updateCategoryByIdUrl: '/Material/KindUpdate',
      updateCategoryStatus: '/Material/KindStatus',
      deleteCategoryByIDUrl: '/Material/KindDelete',
      categoryCheckExist: '/Material/KindCheckExist',

      getCharacteristicsListUrl: '/Material/CharacteristicsList',
      getCharacteristicsByIDUrl: '/Material/CharacteristicsGet',
      createNewCharacteristicsUrl: '/Material/CharacteristicsSubmit',
      updateCharacteristicsByIdUrl: '/Material/CharacteristicsUpdate',
      updateCharacteristicsStatus: '/Material/CharacteristicsStatus',
      deleteCharacteristicsByIDUrl: '/Material/CharacteristicsDelete',
      characteristicsCheckExist: '/Material/CharacteristicsCheckExist',

      getUnitListUrl: '/Material/UnitList',
      getUnitByIDUrl: '/Material/UnitGet',
      createNewUnitUrl: '/Material/UnitSubmit',
      updateUnitByIdUrl: '/Material/UnitUpdate',
      updateUnitStatus: '/Material/UnitStatus',
      deleteUnitByIDUrl: '/Material/UnitDelete',
      unitCheckExist: '/Material/UnitCheckExist',
    },
    assets: {
      getAllListUrl: '/DurableArticle/List',
      getAllUnitUrl: '/DurableArticle/GetAllUnit',

      getTypeListUrl: '/DurableArticle/TypeList',
      getTypeByIDUrl: '/DurableArticle/TypeGet',
      createNewTypeUrl: '/DurableArticle/TypeSubmit',
      updateTypeByIdUrl: '/DurableArticle/TypeUpdate',
      updateTypeStatus: '/DurableArticle/TypeStatus',
      deleteTypeByIDUrl: '/DurableArticle/TypeDelete',
      typeCheckExist: '/DurableArticle/TypeCheckExist',

      getTypeAccountListUrl: '/DurableArticle/TypeAccountList',
      getTypeAccountByIDUrl: '/DurableArticle/TypeAccountGet',
      createNewTypeAccountUrl: '/DurableArticle/TypeAccountSubmit',
      updateTypeAccountByIdUrl: '/DurableArticle/TypeAccountUpdate',
      updateTypeAccountStatus: '/DurableArticle/TypeAccountStatus',
      deleteTypeAccountByIDUrl: '/DurableArticle/TypeAccountDelete',
      typeAccountCheckExist: '/DurableArticle/TypeAccountCheckExist',

      getGroupListUrl: '/DurableArticle/GroupList',
      getGroupByIDUrl: '/DurableArticle/GroupGet',
      createNewGroupUrl: '/DurableArticle/GroupSubmit',
      updateGroupByIdUrl: '/DurableArticle/GroupUpdate',
      updateGroupStatus: '/DurableArticle/GroupStatus',
      deleteGroupByIDUrl: '/DurableArticle/GroupDelete',
      groupCheckExist: '/DurableArticle/GroupCheckExist',

      getCategoryListUrl: '/DurableArticle/KindList',
      getCategoryByIDUrl: '/DurableArticle/KindGet',
      createNewCategoryUrl: '/DurableArticle/KindSubmit',
      updateCategoryByIdUrl: '/DurableArticle/KindUpdate',
      updateCategoryStatus: '/DurableArticle/KindStatus',
      deleteCategoryByIDUrl: '/DurableArticle/KindDelete',
      categoryCheckExist: '/DurableArticle/KindCheckExist',

      getCharacteristicsListUrl: '/DurableArticle/CharacteristicsList',
      getCharacteristicsByIDUrl: '/DurableArticle/CharacteristicsGet',
      createNewCharacteristicsUrl: '/DurableArticle/CharacteristicsSubmit',
      updateCharacteristicsByIdUrl: '/DurableArticle/CharacteristicsUpdate',
      deleteCharacteristicsByIDUrl: '/DurableArticle/CharacteristicsDelete',
      characteristicsCheckExist: '/DurableArticle/CharacteristicsCheckExist',

      getUnitListUrl: '/DurableArticle/UnitList',
      getUnitByIDUrl: '/DurableArticle/UnitGet',
      createNewUnitUrl: '/DurableArticle/UnitSubmit',
      updateUnitByIdUrl: '/DurableArticle/UnitUpdate',
      updateUnitStatus: '/DurableArticle/UnitStatus',
      deleteUnitByIDUrl: '/DurableArticle/UnitDelete',
      unitCheckExist: '/DurableArticle/UnitCheckExist',
    },
    car: {
      getAllListUrl: '/Car/List',
      getAllUnitUrl: '/Car/GetAllUnit',

      getTypeListUrl: '/Car/TypeList',
      getTypeByIDUrl: '/Car/TypeGet',
      createNewTypeUrl: '/Car/TypeSubmit',
      updateTypeByIdUrl: '/Car/TypeUpdate',
      updateTypeStatus: '/Car/TypeStatus',
      deleteTypeByIDUrl: '/Car/TypeDelete',
      typeCheckExist: '/Car/TypeCheckExist',

      getKindListUrl: '/Car/KindList',
      getKindByIDUrl: '/Car/KindGet',
      createNewKindUrl: '/Car/KindSubmit',
      updateKindByIdUrl: '/Car/KindUpdate',
      updateKindStatus: '/Car/KindStatus',
      deleteKindByIDUrl: '/Car/KindDelete',
      kindCheckExist: '/Car/KindCheckExist',

      getCharacteristicsListUrl: '/Car/CharacteristicsList',
      getCharacteristicsByIDUrl: '/Car/CharacteristicsGet',
      createNewCharacteristicsUrl: '/Car/CharacteristicsSubmit',
      updateCharacteristicsByIdUrl: '/Car/CharacteristicsUpdate',
      updateCharacteristicsStatus: '/Car/CharacteristicsStatus',
      deleteCharacteristicsByIDUrl: '/Car/CharacteristicsDelete',
      characteristicsCheckExist: '/Car/CharacteristicsCheckExist',

      getDrivenListUrl: '/Car/DrivenList',
      getDrivenByIDUrl: '/Car/DrivenGet',
      getDrivenDetail: '/Car/CharacteristicsGetDetail',
      createNewDrivenUrl: '/Car/DrivenSubmit',
      updateDrivenByIdUrl: '/Car/DrivenUpdate',
      updateDrivenStatus: '/Car/DrivenStatus',
      deleteDrivenByIDUrl: '/Car/DrivenDelete',
      drivenCheckExist: '/Car/DrivenCheckExist',

      getUnitListUrl: '/Car/UnitList',
      getUnitByIDUrl: '/Car/UnitGet',
      createNewUnitUrl: '/Car/UnitSubmit',
      updateUnitByIdUrl: '/Car/UnitUpdate',
      updateUnitStatus: '/Car/UnitStatus',
      deleteUnitByIDUrl: '/Car/UnitDelete',
      unitCheckExist: '/Car/UnitCheckExist',

      carGet: '/DurableArticleRegistration/CarGet',
      fuelRestoreList: '/DurableArticleRegistration/FuelRestoreList',
      fuelRestoreById: '/DurableArticleRegistration/FuelRestoreById',
      fuelRestoreCreate: '/DurableArticleRegistration/FuelRestoreCreate',
      FuelRestoreUpdate: '/DurableArticleRegistration/FuelRestoreUpdate',
      fuelRestoreDelete: '/DurableArticleRegistration/FuelRestoreDel',

      fuelInsuranceList: '/DurableArticleRegistration/FuelInsuranceList',
      fuelInsuranceById: '/DurableArticleRegistration/FuelInsuranceById',
      fuelInsuranceCreate: '/DurableArticleRegistration/FuelInsuranceCreate',
      fuelInsuranceUpdate: '/DurableArticleRegistration/FuelInsuranceUpdate',
      fuelInsuranceDelete: '/DurableArticleRegistration/FuelInsuranceDel',

      fuelTaxList: '/DurableArticleRegistration/FuelTaxList',

      carInspectionList: '/DurableArticleRegistration/CarInspectionList',
      carInspectionById: '/DurableArticleRegistration/CarInspectionById',
      carInspectionCreate: '/DurableArticleRegistration/CarInspectionCreate',
      carInspectionUpdate: '/DurableArticleRegistration/CarInspectionUpdate',
      carInspectionDelete: '/DurableArticleRegistration/CarInspectionDel',

      fuelBatteryList: '/DurableArticleRegistration/FuelBatteryList',
      fuelBatteryById: '/DurableArticleRegistration/FuelBatteryById',
      fuelBatteryCreate: '/DurableArticleRegistration/FuelBatteryCreate',
      fuelBatteryUpdate: '/DurableArticleRegistration/FuelBatteryUpdate',
      fuelBatteryDelete: '/DurableArticleRegistration/FuelBatteryDel',

      fuelTireList: '/DurableArticleRegistration/FuelTireList',
      fuelTireById: '/DurableArticleRegistration/FuelTireById',
      fuelTireCreate: '/DurableArticleRegistration/FuelTireCreate',
      fuelTireUpdate: '/DurableArticleRegistration/FuelTireUpdate',
      fuelTireDelete: '/DurableArticleRegistration/FuelTireDel',

      fuelGetDetail: '/DurableArticleRegistration/FuelGetDetail',
      getCarFuelDetail: '/DurableArticleRegistration/GetCarFuelDetail',

      fuelAccidentList: '/DurableArticleRegistration/FuelAccidentList',
      fuelAccidentById: '/DurableArticleRegistration/FuelAccidentById',
      fuelAccidentCreate: '/DurableArticleRegistration/FuelAccidentCreate',
      fuelAccidentUpdate: '/DurableArticleRegistration/FuelAccidentUpdate',
      fuelAccidentDelete: '/DurableArticleRegistration/FuelAccidentDel',

      lendHistoryList: '/DurableArticleRegistration/LendHistoryList',
      carRequestList: '/DurableArticleRegistration/CarRequestList',

      pollutionList: '/DurableArticleRegistration/PollutionList',
      pollutionById: '/DurableArticleRegistration/PollutionById',
      pollutionCreate: '/DurableArticleRegistration/PollutionCreate',
      pollutionUpdate: '/DurableArticleRegistration/PollutionUpdate',
      pollutionDelete: '/DurableArticleRegistration/PollutionDel',

      useFuelCreate: '/DurableArticleRegistration/UseFuelCreate',

      getWorkGroupByRegistrationId: '/DurableArticleRegistration/GetWorkGroupByRegistrationId',

      // ข้อมูลครุภัณฑ์
      updateDetailDesc: '/DurableArticleRegistration/UpdateDetailDesc',
      // สถานที่ตั้ง/หน่วยงานรับผิดชอบ
      userOrgRelateList: '/User/UserOrgRelateList',
      updateDetailAgency: '/DurableArticleRegistration/UpdateDetailAgency',
      // หมายเลขครุภัณฑ์
      updateDetailGfmis: '/DurableArticleRegistration/UpdateDetailGfmis',
      // ประเภทเงินและการได้มาของสินทรัพย์ - หน่วยงาน
      updateDetailSourceOf: '/DurableArticleRegistration/UpdateDetailSourceOf',
      // ประเภทเงินและการได้มาของสินทรัพย์ - ส/ท
      updateDetailSourceOfTeam: '/DurableArticleRegistration/UpdateDetailSourceOfTeam',
      // ข้อมูลผู้ขาย/รับจ้าง/บริจาค - หน่วยงาน
      updateDetailStore: '/DurableArticleRegistration/UpdateDetailStore',
      // ข้อมูลผู้ขาย/รับจ้าง/บริจาค - ส/ท
      updateDetailStoreTeam: '/DurableArticleRegistration/UpdateDetailStoreTeam',
      // รายละเอียดครุภัณฑ์ - หน่วยงาน
      updateDetail: '/DurableArticleRegistration/UpdateDetail',
      // รายละเอียดครุภัณฑ์ - ส/ท
      updateDetailTeam: '/DurableArticleRegistration/UpdateDetailTeam',
      // รายละเอียดครุภัณฑ์ รถ - หน่วยงาน
      carUpdateDetail: '/DurableArticleRegistration/CarUpdateDetail',
      // รายละเอียดครุภัณฑ์ รถ - ส/ท
      carUpdateDetailTeam: '/DurableArticleRegistration/CarUpdateDetailTeam',
      // รูป
      updateDetailDocument: '/DurableArticleRegistration/UpdateDetailDocument',
    },
    accessRights: {
      getAllListUrl: '/AccessRights/GetAccessRightsList',
      getAccessRightByIDUrl: '/AccessRights/GetAccessRightsDetail',
      createNewAccessRight: '/AccessRights/CreateAccessRights',
      editAccessRightByID: '/AccessRights/EditAccessRights',
      deleteAccessRightByID: '/AccessRights/DeleteAccessRights',
    },
    menuAccessRights: {
      getAllListUrl: '/MenuAccessRights/GetMenuAccessRightsList',
      getAccessRightByIDUrl: '/MenuAccessRights/GetMenuAccessRightsDetail',
      createNewAccessRight: '/MenuAccessRights/CreateMenuAccessRights',
      editAccessRightByID: '/MenuAccessRights/EditMenuAccessRights',
      deleteAccessRightByID: '/MenuAccessRights/DeleteMenuAccessRights',
    },
    user: {
      getUserByCitizenId: '/UserManagement/GetLDDUserData',
      getUserOrgRelateList: '/User/UserOrgRelateList',
    },
    agency: {
      getAllListUrl: '/Agency/GetAgencyList',
      getMainAgencyList: '/Agency/GetMainAgencyList',
      getMainAgency: '/Agency/GetMainAgency',
      getSubAgency: '/Agency/GetSubAgency',
      updateActiveStatusMainAgency: '/Agency/EditActiveStatusMainAgency',
      updateMainAgencyDetail: '/Agency/EditMainAgencyDetail',
      getSubAgencyList: '/Agency/GetSubAgencyList',
      updateActiveStatusSubAgency: '/Agency/EditActiveStatusSubAgency',
      updateSubAgencyDetail: '/Agency/EditSubAgencyDetail',
      getTakeAgenciesList: '/Agency/GetTakeAgency',
      updateDum: '/Utils/DumpAgency',
      updateDumAgency: '/Agency/Migrate',
      updateSubDum: '/Utils/UpdateSubAgencyHead',
      getLendAgency: '/Agency/GetLendAgency',
      getLendAgencySub: '/Agency/GetLendAgencySub',
      getAllSubAgencyMultiSelection: '/Agency/GetAllWorkGroupMultiSelection'
    },
    userManagement: {
      getAllListUrl: '/UserManagement/GetUserList',
      getUserManagementByIDUrl: '/UserManagement/GetUserDetail',
      createUserManagementRight: '/UserManagement/CreateUser',
      editUserManagementByID: '/UserManagement/EditUser',
      deleteUserManagementByID: '/UserManagement/DeleteUser',
      deleteRightsunderSupervisionByID:
        '/UserManagement/DeleteRightsunderSupervision',
      editUsertActiveFlagByID: '/UserManagement/EditUsertActiveFlag',
      getMasterAgencyAndSubAgency:
        '/UserManagement/GetMasterAgencyAndSubAgency',
      getORGHeadItem: '/UserManagement/GetORGHeadItem',
      getSignature: '/UserManagement/GetSignature',
      getAccessRightsList: '/UserManagement/GetAccessRightsList',
      toggleSecondaryRoleStatus: '/UserManagement/ToggleSecondaryRoleStatus',
    },
    materialRegistration: {
      getListMaterialRegistration:
        '/MaterialRegistration/GetListMaterialRegistration',
      getDetailMaterialRegistration:
        '/MaterialRegistration/GetDetailMaterialRegistration',
      updateMaterialRegistration:
        '/MaterialRegistration/UpdateMaterialRegistration',
      deleteNoneBeginningBalance: '/MaterialRegistration/DeleteMaterialRegistration',
      updateEditMaterialRegistration:
        '/MaterialRegistration/UpdateEditingMaterialRegistration',
      createMaterialRegistration:
        '/MaterialRegistration/InsertMaterialRegistration',
      deleteMaterialRegistration:
        '/MaterialRegistration/DelBeginningBalanceMaterialRegistration',
      insertCommitteeMaterial:
        '/MaterialRegistration/InsertCommitteeMaterialRegistration',
        UpdateCommitteeMaterialRegistration:
        '/MaterialRegistration/UpdateCommitteeMaterialRegistration',
      draftCommitteeMaterial:
        '/MaterialRegistration/DraftCommitteeMaterialRegistration',
      insertInventoryCheck:
        '/MaterialRegistration/InsertInventoryCheckMaterialRegistration',
      getListInventoryCheck:
        '/MaterialRegistration/GetListInventoryCheckMaterialRegistration',
      getDetailInventoryCheck:
        '/MaterialRegistration/GetDetailInventoryCheckMaterialRegistration',
      onCancelAudit:
        '/MaterialRegistration/CancelAuditDraft',
      updateStepAcknowledge: '/MaterialRegistration/UpdateStepAcknowledge',
      getAllOrgMaterialRegistration:
        '/MaterialRegistration/GetMaterialRegistrationNation',
      updateAllOrgMaterialRegistration:
        '/MaterialRegistration/UpdateMaterialRegistrationNation',
      updateSwitchActive: '/MaterialRegistration/UpdateFlagActive',
      getRegistrationMaster:
        '/MaterialRegistration/ListMaterialRegistrationMaster',
      getAllRegistrationMaster:
        '/MaterialRegistration/ListMaterialRegistrationMasterAll',
      insertRegistrationMaster:
        '/MaterialRegistration/InsertMaterialRegistrationMaster',
      searchRegistrationMaster:
        '/MaterialRegistration/GetMasterMaterialRegistrationSearch',
      searchRegistrationDetail: '/MaterialRegistration/test',
      ApproveLeaderCommitteeMaterialRegistration: '/MaterialRegistration/ApproveLeaderCommitteeMaterialRegistration',
    },
    notifyRequirements: {
      getAllMaterialRequestTabOne: '/ProductRequest/Tab1List',
      getMaterialRequestTabOneByRequestId: '/ProductRequest/Tab1Get',
      saveDraft: '/ProductRequest/Tab2SaveDraft',
      createMaterialRequest: '/ProductRequest/Tab2Confirm',
      deleteMaterialRequest: '/ProductRequest/Tab2Delete',
      getAllMaterialRequestTabThree: '/ProductRequest/Tab3List',
      getMaterialRequestTabThreeByRequestId: '/ProductRequest/Tab3Get',
      updateCancelRequest: '/ProductRequest/Tab3Cancel',
      updateCancelPdMaterialRequest: '/ProductRequest/PdRequestCancel',
      updateDraftCancelPdMaterialRequest:
        '/ProductRequest/DraftPdRequestCancel',
      getAllMaterialRequestTabFour: '/ProductRequest/Tab4List',
      getPdDetail: '/ProductRequest/PdDetailGet',
      deletePdDetail: '/ProductRequest/PdDetailDelete',
      getPdTrackingDetail: '/ProductRequest/pdTrackingDetailGet',
      getTrackingHistoryDetail: '/ProductRequest/trackingHistoryDetailGet',
      saveDraftPdDetail: '/ProductRequest/PdSaveDraft',
      createPdDetail: '/ProductRequest/PdConfirm',
      getAllMaterialRequestTabFive: '/ProductRequest/Tab5List',
      rejectPdByPdLeader: '/ProductRequest/PdLeaderReject',
      confirmByPdLeader: '/ProductRequest/PdLeaderConfirm',
      rejectPdByPdDirector: '/ProductRequest/PdDirectorReject',
      confirmByPdDirector: '/ProductRequest/PdDirectorConfirm',
    },
    inspection: {
      cancelConfirm: '/DurableArticleInspection/CancelConfirm',
      getAllInspectionList: '/InspectionMaterial/OfficerList',
      getInspectionMaterialByRequestId: '/InspectionMaterial/Get',
      createInspectionMaterial: '/InspectionMaterial/Create',
      getLeaderInspections: '/InspectionMaterial/LeaderList',
      updateApproveInspection: '/InspectionMaterial/Approve',
      rejectInspection: '/InspectionMaterial/NotApprove',
      getDirectorInspectionsWaitingList:
        '/DurableArticleInspection/WaitingList',
      getDonate: '/DurableArticleInspection/DonateGet',
      getDonateWaitingList: '/DurableArticleInspection/DonateWaitingList',
      getDirectorInspectionsTransferGet:
        '/DurableArticleInspection/TransferGet',
      getDirectorInspectionsWaitingDetail:
        '/DurableArticleInspection/TransferWaitingList',
      getDirectorInspectionsFoundGet: '/DurableArticleInspection/FoundGet',
      getDirectorInspectionsWaitingFoundGet:
        '/DurableArticleInspection/FoundWaitingList',
      getDirectorInspectionsForm: '/DurableArticleInspection/Get',
      DirectorTeamAttatchFileinspector:
        '/DurableArticleInspection/DirectorTeamAttatchFile',
      DirectorTeamDeleteFileinspector:
        '/DurableArticleInspection/DirectorTeamDeleteFile',
      GetResponsible: '/DurableArticleInspection/GetResponsible',
    },
    requisition: {
      getAllMaterialRequisitionTabOne: '/PickUpMaterial/Tab1List',
      getRequisitionMaterial: '/PickUpMaterial/GetDetail',
      deleteRequisitionMaterial: '/PickUpMaterial/DeleteItemDetail',
      saveDraft: '/PickUpMaterial/SaveDraft',
      createRequisitionMaterial: '/PickUpMaterial/Confirm',
      cancel: '/PickUpMaterial/Cancel',
      getAllMaterialRequisitionTabThree: '/PickUpMaterial/Tab3List',
      directorConfirm: '/PickUpMaterial/DirectorConfirm',
      directorReject: '/PickUpMaterial/DirectorReject',
      officerConfirm: '/PickUpMaterial/POfficerConfirm',
      officerReject: '/PickUpMaterial/POfficerReject',
      leaderConfirm: '/PickUpMaterial/LeaderConfirm',
      leaderReject: '/PickUpMaterial/LeaderReject',
      officerFinalConfirm: '/PickUpMaterial/POfficerFinalConfirm',
      finalPickUp: '/PickUpMaterial/NOfficerPickUp',
      mainOfficerConfirm: '/PickUpMaterial/MainOfficerConfirm',
      mainManageConfirm: '/PickUpMaterial/MainLeaderConfirm',
      selfPickUp: '/PickUpMaterial/MainNOfficerPickUp',
      approveMainOfficer: '/PickUpMaterial/MainPOfficerFinalConfirm',
      canCelDraft: '/PickUpMaterial/CancelSaveDraft',
    },
    landAndBuilding: {
      getAllList: '/LandAndBuilding/List',

      unReservedDurable: '/BuildingReturn/UnReserved',
      getBuildingInventoryByName:
        '/BuildingReturn/GetBuildingDurableArticlesUsable',
      getTypeAccList: '/LandAndBuilding/TypeAccList',
      getTypeAcc: '/LandAndBuilding/TypeAccGet',
      createNewAccountType: '/LandAndBuilding/TypeAccSubmit',
      updateTypeAccUpdate: '/LandAndBuilding/TypeAccUpdate',
      updateTypeAccStatus: '/LandAndBuilding/TypeAccStatus',
      deleteTypeAccID: '/LandAndBuilding/TypeAccDelete',
      typeAccCheckExist: '/LandAndBuilding/TypeAccCheckExist',

      getAllListGroup: '/LandAndBuilding/GroupList',
      getGroupByGroupId: '/LandAndBuilding/GroupGet',
      createNewGroup: '/LandAndBuilding/GroupSubmit',
      updateGroupByGroupIdData: '/LandAndBuilding/GroupUpdate',
      updateGroupStatus: '/LandAndBuilding/GroupStatus',
      deleteGroupByGroupID: '/LandAndBuilding/GroupDelete',
      groupCheckExist: '/LandAndBuilding/GroupCheckExist',

      getAllListType: '/LandAndBuilding/TypeList',
      getTypeByTypeId: '/LandAndBuilding/TypeGet',
      createNewType: '/LandAndBuilding/TypeSubmit',
      updateTypeByTypeIdData: '/LandAndBuilding/TypeUpdate',
      updateTypeStatus: '/LandAndBuilding/TypeStatus',
      deleteTypeByTypeID: '/LandAndBuilding/TypeDelete',
      typeCheckExist: '/LandAndBuilding/TypeCheckExist',

      getAllListCategory: '/LandAndBuilding/KindList',
      getCategoryByCategoryId: '/LandAndBuilding/KindGet',
      createNewCategory: '/LandAndBuilding/KindSubmit',
      updateCategoryByCategoryIdData: '/LandAndBuilding/KindUpdate',
      updateCategoryStatus: '/LandAndBuilding/KindStatus',
      deleteCategoryByCategoryID: '/LandAndBuilding/KindDelete',
      categoryCheckExist: '/LandAndBuilding/KindCheckExist',

      getAllListProperty: '/LandAndBuilding/CharacteristicsList',
      getPropertyByPropertyId: '/LandAndBuilding/CharacteristicsGet',
      createNewProperty: '/LandAndBuilding/CharacteristicsSubmit',
      updatePropertyByPropertyIdData: '/LandAndBuilding/CharacteristicsUpdate',
      updatePropertyStatus: '/LandAndBuilding/CharacteristicsStatus',
      deletePropertyByPropertyID: '/LandAndBuilding/CharacteristicsDelete',
      PropertyCheckExist: '/LandAndBuilding/CharacteristicsCheckExist',
    },
    assetsControl: {
      getImgPath: '/File/Serve/',
      getAssetsControlList: '/DurableArticleRegistration/List',
      getAllAssetsList: '/DurableArticleRegistration/GetAll',
      getAsssetDetail: '/DurableArticleRegistration/Get',
      getAssetRepair: '/DurableArticleRegistration/RepairList',
      addNewAssetRepair: '/DurableArticleRegistration/RepairConfirm',
      updateDetailDocument: '/DurableArticleRegistration/UpdateDetailDocument',
      attachFile: '/DurableArticleRegistration/AttachFileTransfer',
      GetAllWorkGroup: '/Agency/GetAllWorkGroup',
      GetWorkGroup: '/BuildingRegistration/GetWorkGroup',
      updateDetailDesc: '/DurableArticleRegistration/UpdateDetailDesc',
      updateDetailAgency: '/DurableArticleRegistration/UpdateDetailAgency',
      updateDetailGfmis: '/DurableArticleRegistration/UpdateDetailGfmis',
      updateDetailSourceOf: '/DurableArticleRegistration/UpdateDetailSourceOf',
      updateDetailSourceOfTeam: '/DurableArticleRegistration/UpdateDetailSourceOfTeam',
      updateDetailStore: '/DurableArticleRegistration/UpdateDetailStore',
      updateDetailStoreTeam: '/DurableArticleRegistration/UpdateDetailStoreTeam',
      updateDetail: '/DurableArticleRegistration/UpdateDetail',
      updateDetailTeam: '/DurableArticleRegistration/UpdateDetailTeam',
    },
    sourceOfAssets: {
      sourceOfAssetsList: '/SourceOfAssets/List',
      SubItemListActive: '/SourceOfAssets/SubItemListActive',
      sourceOfAssetsSubItemList: '/SourceOfAssets/SubItemList',
      sourceOfAssetsSubItemSubmit: '/SourceOfAssets/SubItemSubmit',
      sourceOfAssetsSubItemStatus: '/SourceOfAssets/SubItemStatus',
      sourceOfAssetsSubItemGet: '/SourceOfAssets/SubItemGet',
      sourceOfAssetsSubItemUpdate: '/SourceOfAssets/SubItemUpdate',
      sourceOfAssetsSubItemDelete: '/SourceOfAssets/SubItemDelete',
      sourceOfAssetsSubItemExist: '/SourceOfAssets/SubItemCheckExist',

      getsourceOfAsset: '/SourceOfAssets/Get',
      updateSourceOfAsset: '/SourceOfAssets/MainItemUpdate',
      checkSourceOfAssetExist: '/SourceOfAssets/MainItemCheckExist',
      sourceOfAssetsMainItemStatus: '/SourceOfAssets/MainItemStatus ',

    },
    common: {
      getSubAgencyByAgencyList: '/Common/SubAgencyByAgencyList',

      GetAllByUserId: '/Common/GetAllByUserId',
      getAllUser: '/Common/GetAll',
      getAllMethodSellShow: '/Common/GetAllMethodSellShow',

      getAllCountStatus: '/Common/GetAllCountStatus',
      getAllRegistrationChangeStatus: '/Common/GetAllRegistrationChangeStatus',
      getBuildingSellMethod: '/Common/GetAllBuildingMethodSell',
      getAllAcquisitionMethodAct: '/Common/GetAllAcquisitionMethodAct',
      getAllAccessCarRequest: '/Common/GetAllAccessCarRequest',

      getAllGroupInformation: '/common/GetAllInformationTechnologyCenter', //ศทส.
      getAllStaff: '/common/GetAllStaff',
      getAllDirector: '/common/GetAllDivisionDirector',
      getAllGroupDirector: '/common/GetAllGroupDirector',
      getAllPOfficer: '/common/GetAllMaterialOfficer',
      getAllPLeader: '/common/GetAllMaterialManager',
      getAllCentralGroupAssetDirector: '/common/GetAllAssetManagementDirector',
      getAllAssetTeam: '/common/GetAllAssetManagementTeam',
      getAllAgencyAdmin: '/common/GetAllDepartmentAdmin',
      getAllInternalAudit: '/common/GetAllInternalAuditGroup',
      getAllTreasuryDivision: '/common/GetAllTreasuryDivision', //กองคลัง
      getAllPlanningPerformanceDivision:
        '/common/GetAllPlanningPerformanceDivision', //สสผ.
      getAllInventoryCheckingCommittee:
        '/common/GetAllInventoryCheckingCommittee',
      getAllCarAuditor: '/common/GetAllCarAuditor',
      getAllCarDriver: '/common/GetAllDriver',
      getAllDriverUnderDepartment: '/common/GetAllDriverUnderDepartment',

      GetAllMainAgencyList: '/common/MainAgencyList',
      GetAllAgencyByMainAgencyList: '/common/AgencyByMainAgencyList',
      GetAllInventoryCheckingCommitteeByAgencyType:
        '/common/GetAllInventoryCheckingCommitteeByAgencyType',
      GetAllCarRegistrationProvince: '/common/GetAllCarRegistrationProvince',
      GetCountPosition: '/common/GetCountPosition',
      EditRemark: '/DurableArticleInspection/EditRemark',
      GetInventoryCheckingCommitteeByOrgId: '/Common/GetInventoryCheckingCommitteeByOrgId',
    },
    Report: {
      AllDurableArticleRestore: '/Report/AllDurableArticleRestore',
      AllDurableArticleRestoreGF: '/Report/AllDurableArticleRestoreGF',
      AllDurableArticleReturn: '/Report/AllDurableArticleReturn',
      AllDurableArticleSell: '/Report/AllDurableArticleSell',
      AllDurableArticleCount: '/Report/AllDurableArticleCount',
      AllDurableArticleInspection: '/Report/AllDurableArticleInspection',
      AllDurableArticleRegistrationRemain: '/Report/AllDurableArticleRegistrationRemain',
      AllDurableArticleRegistrationLend: '/Report/AllDurableArticleRegistrationLend',
      AllDurableArticleRegistrationLendState: '/Report/AllDurableArticleRegistrationLendState',
      AllDurableArticleRegistrationLendAgency: '/Report/AllDurableArticleRegistrationLendAgency',
      DurableArticleInspection: '/DurableArticleInspection/Get',
      DurableArticleRestore: '/Report/DurableArticleRestore',
      DurableArticleRestoreCar: '/Report/DurableArticleRestoreCar',
      AllCarUseFuel: '/Report/AllCarUseFuel',
      DurableArticleTake: '/DurableArticleTake/GetDetail',
      SnapShotGetDetail: '/DurableArticleTake/SnapShotGetDetail',
      DurableArticleReturn: '/DurableArticleReturn/GetDetail',
      DurableArticleReturnSnapShotGetDetail: '/DurableArticleReturn/SnapShotGetDetail',
      AllUseCarRequest: '/Report/AllUseCarRequest',
      GetLandReport: '/BuildingReport/GetLandReport',
      GetBuildingReport: '/BuildingReport/GetBuildingReport',
      GetInspectionReport: '/BuildingReport/GetInspectionReport',
      GetMaintenanceReport: '/BuildingReport/GetMaintenanceReport',
      GetReturnReport: '/BuildingReport/GetReturnReport',
      GetDisposalReport: '/BuildingReport/GetDisposalReport',
      GetRemainReport: '/BuildingReport/GetRemainReport',


      GetInspectionPdf: '/BuildingReport/GetInspectionPdf',
      GetMaintenanceHistoryReport: '/BuildingReport/GetMaintenanceHistoryReport',
      GetMaintenanceByGfmisReport: '/BuildingReport/GetMaintenanceByGfmisReport',
      BuildingReturnSnapShotGetDetail: '/BuildingReturn/SnapShotGetDetail',
      BuildingReturnSnap: '/BuildingReturn/GetDetail',
      BuildingTakeSnapShotGetDetail: '/BuildingTake/SnapShotGetDetail',




      GetRoomReport: '/BuildingReport/GetRoomReport',
      GetOfficialResidenceLog: '/BuildingReport/GetOfficialResidenceLog',

      SummerizeRepair: '/Report/SummerizeRepair',

      SummerizeTransferItem: '/Report/SummerizeTransferItem',
      SummerizeSell: '/Report/SummerizeSell',
      DurableArticleCountRemain: '/Report/DurableArticleCountRemain',
      SummaryCountRemain: '/Report/SummaryCountRemain',
      RegistrationItemDepreciation: '/Report/RegistrationItemDepreciation',
      RegistrationItemDepreciationTotal: '/Report/RegistrationItemDepreciationTotal',
      RegistrationItemDeteriorated: '/Report/RegistrationItemDeteriorated',
      SummaryRegistrationItemDeteriorated: '/Report/SummaryRegistrationItemDeteriorated',
      DetailInspectionByYear: '/Report/DetailInspectionByYear',
      SummaryDetailInspectionByYear: '/Report/SummaryDetailInspectionByYear',
      SummaryAllDurableArticleRegistrationRemain: '/Report/SummaryAllDurableArticleRegistrationRemain',
      DALendAgriByYear: '/Report/DALendAgriByYear',
      DALendNotReturnAndNotExceed: '/Report/DALendNotReturnAndNotExceed',
      DALendNotReturnAndExceed: '/Report/DALendNotReturnAndExceed',
      DALendByTypeAcc: '/Report/DALendByTypeAcc',
      DALendYearly: '/Report/DALendYearly',
      DALendReturnAndExceed: '/Report/DALendReturnAndExceed',

      DARegistrationCar: '/Report/DARegistrationCar',
      DARegistrationCarByAgency: '/Report/DARegistrationCarByAgency',
      DARegistrationCarAccident: '/Report/DARegistrationCarAccident',
      DARegistrationCarAct: '/Report/DARegistrationCarAct',

      DARegistrationCarActYearly: '/Report/DARegistrationCarActYearly',
      DARegistrationCarInsurance: '/Report/DARegistrationCarInsurance',
      SummaryDARegistrationCarInsurance: '/Report/SummaryDARegistrationCarInsurance',
      DARegistrationCarUseFuel: '/Report/DARegistrationCarUseFuel',
      DARegistrationOtherUseFuel: '/Report/DARegistrationOtherUseFuel',
      DARegistrationCarRestore: '/Report/DARegistrationCarRestore',
      SummaryDARegistrationCarRestore: '/Report/SummaryDARegistrationCarRestore',
      SummaryDARegistrationUseFuel: '/Report/SummaryDARegistrationUseFuel',
      DetailDARegistrationUseFuel: '/Report/DetailDARegistrationUseFuel',
      SummaryDetailDARegistrationUseFuel: '/Report/SummaryDetailDARegistrationUseFuel',

      DARegistrationCarByTypeAndAge: '/Report/DARegistrationCarByTypeAndAge',
      DARegistrationCarStopUsing: '/Report/DARegistrationCarStopUsing',
      SummaryDARegistrationCarStopUsing: '/Report/SummaryDARegistrationCarStopUsing',
      DetailDARegistrationCarTax: '/Report/DetailDARegistrationCarTax',
      SummaryDetailDARegistrationCarTax:'/Report/SummaryDetailDARegistrationCarTax',
      DetailDARegistrationCarTaxOver7:'/Report/DetailDARegistrationCarTaxOver7',
      SummaryDetailDARegistrationCarTaxOver7:'/Report/SummaryDetailDARegistrationCarTaxOver7',
      DARegistrationCarPollution:'/Report/DARegistrationCarPollution',

















    },
    Dashboard: {
      DATypeAccRemain: '/Dashboard/DATypeAccRemain',
      DASummary: '/Dashboard/DASummary',
      DASellSummary: '/Dashboard/DASellSummary',
      DATakeAndWithdraw: '/Dashboard/DATakeAndWithdraw',
      DAUseFuel: '/Dashboard/DAUseFuel',
      DACarInspection: '/Dashboard/DACarInspection',
      DAActAndInsurance: '/Dashboard/DAActAndInsurance',
      DATypeAccStatusRemain: '/Dashboard/DATypeAccStatusRemain',
      DATypeAccAgencyRemain: '/Dashboard/DATypeAccAgencyRemain',
      SummaryOfLand: '/BuildingDashboard/SummaryOfLand',
      SummaryOfBuilding: '/BuildingDashboard/SummaryOfBuilding',
      GetSummaryOfLandByOrg: '/BuildingDashboard/GetSummaryOfLandByOrg',
      GetRemainBuildingsByStatus: '/BuildingDashboard/GetRemainBuildingsByStatus',
      GetRemainBuildingsByOrg: '/BuildingDashboard/GetRemainBuildingsByOrg',
      AnnualAssetSummary: '/BuildingDashboard/AnnualAssetSummary',
      AnnualDisposalsSummary: '/BuildingDashboard/AnnualDisposalsSummary',
      AnnualValueSummary: '/BuildingDashboard/AnnualValueSummary',
    },
    addAssetInspection: {
      searchAsset: '/DurableArticle/Search',
      advanceSearch: '/DurableArticle/AdvanceSearch',
      GenCodeAsset: '/DurableArticleInspection/GenerateRegistrationNumber',
      OfficerConfirm: '/DurableArticleInspection/OfficerConfirm',
      DonateOfficerConfirm: '/DurableArticleInspection/DonateOfficerConfirm',
      TransferOfficerConfirm:
        '/DurableArticleInspection/TransferOfficerConfirm',
      FoundOfficerConfirm: '/DurableArticleInspection/FoundOfficerConfirm',
      DraftInspection: '/DurableArticleInspection/Draft',
      DonateDraftInspection: '/DurableArticleInspection/DonateDraft',
      TransferDraftInspection: '/DurableArticleInspection/TransferDraft',
      FoundDraftInspection: '/DurableArticleInspection/FoundDraft',
      CentralTeamConfirm: '/DurableArticleInspection/CentralTeamConfirm',
      CancelInspection: '/DurableArticleInspection/CentralTeamReject',
      LeaderConfirmConfirm: '/DurableArticleInspection/LeaderConfirm',
      LeaderReject: '/DurableArticleInspection/LeaderReject',
      DirectorConfirm: '/DurableArticleInspection/DirectorApprove',
      DirectorReject: '/DurableArticleInspection/DirectorReject',
      transferInspection: '/DurableArticleInspection/TransferList',
      DocumentReject: '/DurableArticleInspection/DocumentReject',
      DocumentApprove: '/DurableArticleInspection/DocumentApprove',
    },
    projects: {
      projectList: '/Project/ProjectList',
      projectSubmit: '/Project/ProjectSubmit',
      projectGet: '/Project/ProjectGet',
      projectStatus: '/Project/ProjectStatus',
      projectCheckExist: '/Project/ProjectCheckExist',
      projectUpdate: '/Project/ProjectUpdate',
      projectDelete: '/Project/ProjectDelete',
    },
    subProjects: {
      projectSubItemList: '/Project/ProjectSubItemList',
      projectSubItemSubmit: '/Project/ProjectSubItemSubmit',
      projectSubItemGet: '/Project/ProjectSubItemGet',
      projectSubItemStatus: '/Project/ProjectSubItemStatus',
      projectSubItemUpdate: '/Project/ProjectSubItemUpdate',
      projectSubItemDelete: '/Project/ProjectSubItemDelete',
      projectSubItemCheckExist: '/Project/ProjectSubItemCheckExist',
    },
    withdraw: {
      getAllWithdrawList: '/DurableArticleWithdraw/List',
      getAllActiveList: '/DurableArticleRegistration/GetAllActiveList',
      getAllActiveListPage: '/DurableArticleRegistration/GetAllActiveListPage',
      addToCart: '/DurableArticleWithdraw/AddToCart',
      cartList: '/DurableArticleWithdraw/CartList',
      cartRemove: '/DurableArticleWithdraw/CartRemove',
      cartConfirm: '/DurableArticleWithdraw/CartConfirm',
      saveDraft: '/DurableArticleWithdraw/SaveDraft',
      cancelConfirm: '/DurableArticleWithdraw/CancelConfirm',
      withdrawConfirm: '/DurableArticleWithdraw/Confirm',
      withdrawDetail: '/DurableArticleWithdraw/GetDetail',

      directorGroupReject: '/DurableArticleWithdraw/DirectorGroupReject',
      officerReject: '/DurableArticleWithdraw/OfficerReject',
      leaderReject: '/DurableArticleWithdraw/LeaderReject',
      directorReject: '/DurableArticleWithdraw/DirectorReject',

      directorGroupConfirm: '/DurableArticleWithdraw/DirectorGroupConfirm',
      officerConfirm: '/DurableArticleWithdraw/OfficerConfirm',
      leaderConfirm: '/DurableArticleWithdraw/LeaderConfirm',
      directorConfirm: '/DurableArticleWithdraw/DirectorConfirm',

      officerReceive: '/DurableArticleWithdraw/OfficerReceive',
      officerPay: '/DurableArticleWithdraw/OfficerPay',
    },
    rentForm: {
      DurablesList: '/DurableArticleLend/LendList',
      LendDetail: '/DurableArticleLend/LendDetail',
      AgencyGetAllAgency: '/Agency/GetAllAgency',
      LendDraft: '/DurableArticleLend/LendDraft',
      ConfirmLendConfirm: '/DurableArticleLend/LendConfirm',
      RejectLendPOfficerReject: '/DurableArticleLend/LendPOfficerReject',
      ConfirmLendPOfficerConfirm: '/DurableArticleLend/LendPOfficerConfirm',
      LendLeaderConfirm: '/DurableArticleLend/LendLeaderConfirm',
      LendPLeaderReject: '/DurableArticleLend/LendLeaderReject',
      LendDirectorConfirm: '/DurableArticleLend/LendDirectorConfirm',
      LendDirectorReject: '/DurableArticleLend/LendDirectorReject',
      GetAllActiveList: '/DurableArticleRegistration/GetAllActiveList',
      GetAllActiveList2: '/DurableArticleTreasury/TakeList',
      GetAllActiveList3: '/DurableArticleTreasury/SellList',
      LendAddToCart: '/DurableArticleLend/LendAddToCart',
      LendCartList: '/DurableArticleLend/LendCartList',
      LendCartConfirm: '/DurableArticleLend/LendCartConfirm',
      BorrowPOfficerConfirm: '/DurableArticleLend/BorrowPOfficerConfirm',
      BorrowPLeaderConfirm: '/DurableArticleLend/BorrowPLeaderConfirm',
      BorrowPLeaderReject: '/DurableArticleLend/BorrowPLeaderReject',
      BorrowDirectorConfirm: '/DurableArticleLend/BorrowDirectorConfirm',
      BorrowDirectorReject: '/DurableArticleLend/BorrowDirectorReject',
      DistributeConfirm: '/DurableArticleLend/DistributeConfirm',
      ReceiveConfirm: '/DurableArticleLend/ReceiveConfirm',
      ReturnSendConfirm: '/DurableArticleLend/ReturnSendConfirm',
      ReturnReceiveConfirm: '/DurableArticleLend/ReturnReceiveConfirm',
      AddToCart: '/DurableArticleLend/AddToCart',
      CartList: '/DurableArticleLend/CartList',
      CartConfirm: '/DurableArticleLend/CartConfirm',
      CancelConfirm: '/DurableArticleLend/CancelConfirm',
    },
    landandbuilding: {
      getLandTypes: '/LandAndBuildingInspection/GetLandTypes',
      AttachBuildingFiles: '/LandAndBuildingInspection/AttachBuildingFiles',
      getLandAndBuilding:
        '/LandAndBuildingInspection/GetBuildingInspectionList',
      craetLandAndBuilding:
        '/LandAndBuildingInspection/CreateBuildingInspection',
      EditBuildingInspection:
        '/LandAndBuildingInspection/EditBuildingInspection',
      landAndBuildingDetail:
        '/LandAndBuildingInspection/GetBuildingInspectionDetail',
      getBuildingInspectionForm:
        '/LandAndBuildingInspection/GetBuildingInspectionForm',
      GetGFMIS: '/LandAndBuildingInspection/GetGFMIS',
      GetGroup: '/LandAndBuildingInspection/GetGroup',
      GetType: '/LandAndBuildingInspection/GetType',
      GetKind: '/LandAndBuildingInspection/GetKind',
      GetUnit: '/LandAndBuildingInspection/GetUnit',
      GetCharacteristics: '/LandAndBuildingInspection/GetCharacteristic',
      SearchByGenericName: '/LandAndBuildingInspection/SearchByGenericName',
      GenerateDurableArticlesCode:
        '/LandAndBuildingInspection/GenerateDurableArticlesCode',
      submitDirectorInspectionForm:
        '/LandAndBuildingInspection/DirectorApprove',
      rejectLeaderConfirm: '/LandAndBuildingInspection/LeaderReject',
      submitLeaderConfirm: '/LandAndBuildingInspection/LeaderApprove',
      rejectTeamConfirm: '/LandAndBuildingInspection/CentralTeamReject',
      submitCentralTeamConfirm: '/LandAndBuildingInspection/CentralTeamApprove',
      rejectDirectorConfirm: '/LandAndBuildingInspection/DirectorReject',
      getBuildingRegistrationList:
        '/BuildingRegistration/GetBuildingRegistrationList',
      GetBuildingRegistrationListPagination:
        '/BuildingRegistration/GetBuildingRegistrationListPagination',
      getBuildingRegistrationInformationDetail:
        '/BuildingRegistration/GetBuildingRegistrationInformation',
      editBuildingRegistrationDetail:
        '/BuildingRegistration/EditBuildingRegistrationInformation',
      editAgency: '/BuildingRegistration/EditAgency',
      editSourceOfAsset: '/BuildingRegistration/EditSourceOfAsset',
      editDocumentNumber: '/BuildingRegistration/EditDocumentNumber',
      editDurableArticlesFiles:
        '/BuildingRegistration/EditDurableArticlesFiles',
      editOtherInfo: '/BuildingRegistration/EditOtherInfo',
      editDurableArticlesRemark:
        '/BuildingRegistration/EditDurableArticlesRemark',
      getRoomList: '/BuildingRegistration/RoomList',
      editDurableArticlesNumber:
        '/BuildingRegistration/EditDurableArticlesNumber',
      editRoom: '/BuildingRegistration/EditRoom',
      addRoom: '/BuildingRegistration/AddRoom',
      deleteRoom: '/BuildingRegistration/DeleteRoom',
      addGuest: '/BuildingRegistration/MappingGuestsWithRoom',
      getGuest: '/BuildingRegistration/Guests',
      deleteGuest: '/BuildingRegistration/DeleteGuest',
      getUsageHistoryList: '/BuildingRegistration/UsageHistoryList',
      getMaintrainanceList: '/BuildingRegistration/MaintrainanceList',
      addMaintrainanceList: '/BuildingRegistration/AddMaintrainanceList',
      EditBuilding: '/BuildingRegistration/EditBuilding',
      EditAgency: '/BuildingRegistration/EditAgency',
      EditBuildingNumber: '/BuildingRegistration/EditBuildingNumber',
      EditSourceOfAsset: '/BuildingRegistration/EditSourceOfAsset',
      EditCompanyDetail: '/BuildingRegistration/EditCompanyDetail',
      EditBuildingDetail: '/BuildingRegistration/EditBuildingDetail',
      EditDurableArticleImage: '/BuildingRegistration/EditDurableArticleImage',
      getMaintrainanceDetail: '/BuildingRegistration/MaintrainanceDetail',
      EditMaintrainanceDetail: '/BuildingRegistration/EditMaintrainanceList',
      deleteMaintenance: '/BuildingRegistration/DeleteMaintenanceItems',
      // Master
      Provinces: '/AdministrativeArea/Provinces',
      District: '/AdministrativeArea/District',
      SubDistrict: '/AdministrativeArea/SubDistrict',
      // LandRegistration
      GetKindList: '/LandAndBuildingInspection/GetKindList',
      CancelledLandParcel: '/LandRegistration/CancelledLandParcel',
      GetHistoryDetail: '/LandRegistration/GetHistoryDetail',
      CancelInspection: '/LandAndBuildingInspection/CancelInspection',
      Units: '/LandAndBuildingInspection/Units',
      EditMappingGuestsWithRoom:
        '/BuildingRegistration/EditMappingGuestsWithRoom',
      getBuildingDurableArticles:
        '/LandRegistration/GetBuildingDurableArticles',
      GetBuildingDurableArticles:
        '/LandAndBuildingInspection/GetBuildingDurableArticles',
      GetHistoryListOne: '/LandRegistration/GetHistoryListOne',
      GetHistoryListTwo: '/LandRegistration/GetHistoryListTwo',
      GetLandParcelsList: '/LandRegistration/GetLandParcelsList',
      GetLandParcelsDetail: '/LandRegistration/GetLandParcelsDetail',
      CreateLandParcels: '/LandRegistration/CreateLandParcels',
      EditLandParcels: '/LandRegistration/EditLandParcels',
      DeleteLandParcels: '/LandRegistration/DeleteLandParcels',
      GetLandForm1Detail: '/LandRegistration/GetLandForm1Detail',
      GetLandForm2Detail: '/LandRegistration/GetLandForm2Detail',
      CreateLandForm1: '/LandRegistration/CreateLandForm1',
      CreateLandForm2: '/LandRegistration/CreateLandForm2',
      EditLandForm1: '/LandRegistration/EditLandForm1',
      EditLandForm2: '/LandRegistration/EditLandForm2',
      // เจ้าหน้าที่
      LeaderApprove: '/LandRegistration/LeaderApprove',
      LeaderReject: '/LandRegistration/LeaderReject',
      // ทีมงานสินทรัพย์
      CentralTeamApprove: '/LandRegistration/CentralTeamApprove',
      CentralTeamReject: '/LandRegistration/CentralTeamReject',
      // อนุมัติสินทรัพย์ เเละ ผอ. สินทรัพย์ ข้อมูลที่ 1
      AssetTeamEditFrom1: '/LandRegistration/AssetTeamEditFrom1',
      AssetDirectorEditFrom1: '/LandRegistration/AssetDirectorEditFrom1',
      // อนุมัติสินทรัพย์ เเละ ผอ. สินทรัพย์ ข้อมูลที่ 2
      AssetTeamEditFrom2: '/LandRegistration/AssetTeamEditFrom2',
      AssetDirectorEditFrom2: '/LandRegistration/AssetDirectorEditFrom2',
      // ผอ. สินทรัพย์
      DirectorApprove: '/LandRegistration/DirectorApprove',
      DirectorReject: '/LandRegistration/DirectorReject',
      // ผอ.สินทรัพย์ รอโอน
      EvidenceOfTransferFiles: '/BuildingRegistration/EvidenceOfTransferFiles',
      ApproveWaitingToBeTransferred:
        '/LandAndBuildingInspection/ApproveWaitingToBeTransferred',
      RejectWaitingToBeTransferred:
        '/LandAndBuildingInspection/RejectWaitingToBeTransferred',
      // LandRegistration
      GetLandRegistrationList: '/LandRegistration/GetLandRegistrationList',
      // เเนบไฟล์รอโอน
      AttachEvidenceOfTransfer:
        '/BuildingRegistration/AttachEvidenceOfTransfer',

      GetBorrowingOrList: '/BuildingBorrowing/BorrowingList',
      //in
      GetBorrowingInOrList: '/BuildingBorrowing/BorrowingListInOrg',
      GetBorrowingInOrgDetail: '/BuildingBorrowing/BorrowingInOrgDetail',
      CreateBorrowingInOrg: '/BuildingBorrowing/CreateBorrowingInOrg',
      EditBorrowingInOrg: '/BuildingBorrowing/EditBorrowingInOrg',

      //out
      GetBorrowingListOrgList: '/BuildingBorrowing/BorrowingListOutOrg',
      GetBorrowingOutOrgDetail: '/BuildingBorrowing/BorrowingOutOrgDetail',
      CreateBorrowingOutOrg: '/BuildingBorrowing/CreateBorrowingOutOrg',
      EditBorrowingOutOrg: '/BuildingBorrowing/EditBorrowingOutOrg',

      //Farmer
      GetBorrowingFarmerList: '/BuildingBorrowing/BorrowingListAgriculturist',
      GetBorrowingFarmerDetail:
        '/BuildingBorrowing/BorrowingAgriculturistDetail',
      CreateBorrowingFarmer: '/BuildingBorrowing/CreateBorrowingAgriculturist',
      EditBorrowingFarmer: '/BuildingBorrowing/EditBorrowingAgriculturist',
      //State
      GetBorrowingStateList: '/BuildingBorrowing/BorrowingListGovernmentAgency',
      GetBorrowingGovernmentAgencyDetail:
        '/BuildingBorrowing/BorrowingGovernmentAgencyDetail',
      CreateBorrowingState:
        '/BuildingBorrowing/CreateBorrowingGovernmentAgency',
      EditBorrowingState: '/BuildingBorrowing/EditBorrowingGovernmentAgency',

      GetBorrowingForm: '/BuildingBorrowing/DefaultBorrowingForm',

      //Supply
      SupplyApproveOutOrg:
        '/BuildingBorrowing/SupplyOfficeBorrowerApproveOutOrg',
      SupplyRejectOutOrg: '/BuildingBorrowing/SupplyOfficeBorrowerRejectOutOrg',
      SupplyApproveInOrg: '/BuildingBorrowing/SupplyOfficeBorrowerApproveInOrg',
      SupplyRejectInOrg: '/BuildingBorrowing/SupplyOfficeBorrowerRejectInOrg',
      SupplyLenderAddBorrowListOutOrg:
        '/BuildingBorrowing/SupplyOfficeLenderAddBorrowListOutOrg',

      //Leader
      LeaderBorrowerApproveState:
        '/BuildingBorrowing/LeaderBorrowerApproveGovernmentAgency',
      LeaderBorrowerRejectState:
        '/BuildingBorrowing/LeaderBorrowerRejectGovernmentAgency',
      LeaderBorrowerApproveFarmer:
        '/BuildingBorrowing/LeaderBorrowerApproveAgriculturist',
      LeaderBorrowerRejectFarmer:
        '/BuildingBorrowing/LeaderBorrowerRejectAgriculturist',
      LeaderBorrowerApproveInOrg:
        '/BuildingBorrowing/LeaderBorrowerApproveInOrg',
      LeaderBorrowerRejectInOrg: '/BuildingBorrowing/LeaderBorrowerRejectInOrg',
      LeaderBorrowerApproveOutOrg:
        '/BuildingBorrowing/LeaderBorrowerApproveOutOrg',
      LeaderBorrowerRejectOutOrg:
        '/BuildingBorrowing/LeaderBorrowerRejectOutOrg',
      LeaderLenderApproveOutOrg: '/BuildingBorrowing/LeaderLenderApproveOutOrg',
      LeaderLenderRejectOutOrg: '/BuildingBorrowing/LeaderLenderRejectOutOrg',

      //Director
      DirectorBorrowerApproveState:
        '/BuildingBorrowing/DirectorBorrowerApproveGovernmentAgency',
      DirectorBorrowerRejectState:
        '/BuildingBorrowing/DirectorBorrowerRejectGovernmentAgency',
      DirectorBorrowerApproveFarmer:
        '/BuildingBorrowing/DirectorBorrowerApproveAgriculturist',
      DirectorBorrowerRejectFarmer:
        '/BuildingBorrowing/DirectorBorrowerRejectAgriculturist',
      DirectorBorrowerApproveInOrg:
        '/BuildingBorrowing/DirectorBorrowerApproveInOrg',
      DirectorBorrowerRejectInOrg:
        '/BuildingBorrowing/DirectorBorrowerRejectInOrg',
      DirectorBorrowerApproveOutOrg:
        '/BuildingBorrowing/DirectorBorrowerApproveOutOrg',
      DirectorBorrowerRejectOutOrg:
        '/BuildingBorrowing/DirectorBorrowerRejectOutOrg',
      DirectorLenderApproveOutOrg:
        '/BuildingBorrowing/DirectorLenderApproveOutOrg',
      DirectorLenderRejectOutOrg:
        '/BuildingBorrowing/DirectorLenderRejectOutOrg',

      ReceiveDurableArticlesOutOrg:
        '/BuildingBorrowing/ReceiveDurableArticlesOutOrg',
      ReceiveDurableArticlesInOrg:
        '/BuildingBorrowing/ReceiveDurableArticlesInOrg',
      ReceiveDurableArticlesGovernmentAgency:
        '/BuildingBorrowing/ReceiveDurableArticlesGovernmentAgency',
      LendingDurableArticlesAgriculturist:
        '/BuildingBorrowing/LendingDurableArticlesAgriculturist',

      ReceiveReturnGovernmentAgency:
        '/BuildingBorrowing/ReceiveReturnGovernmentAgency',
      ReceiveReturnAgriculturist:
        '/BuildingBorrowing/ReceiveReturnAgriculturist',
      ReceiveReturnInOrg: '/BuildingBorrowing/ReceiveReturnInOrg',
      BorrowerReturnInOrg: '/BuildingBorrowing/BorrowerReturnInOrg',

      ReceiveReturnOutOrg: '/BuildingBorrowing/ReceiveReturnOutOrg',
      BorrowerReturnOutOrg: '/BuildingBorrowing/BorrowerReturnOutOrg',

      LenderApproveLendingInOrg: '/BuildingBorrowing/LenderApproveLendingInOrg',
      LenderApproveLendingOutOrg:
        '/BuildingBorrowing/LenderApproveLendingOutOrg',
      BuildingBorrowing_LenderApproveLendingOutOrg:
        '/BuildingBorrowing/GetBuildingDurableArticles',
      CancelBorrowing: '/BuildingBorrowing/CancelBorrowing'
    },
    governmentVehicle: {
      getAllVehicleList: '/DurableArticleCarRequest/List',
      getVehicleDetail: '/DurableArticleCarRequest/GetDetail',
      draft: '/DurableArticleCarRequest/Draft',
      confirm: '/DurableArticleCarRequest/Confirm',
      carList: '/DurableArticleCarRequest/CarList',
      preSave: '/DurableArticleCarRequest/PreSave',
      carSelected: '/DurableArticleCarRequest/CarSelected',
      leaderConfirm: '/DurableArticleCarRequest/LeaderConfirm',
      directorConfirm: '/DurableArticleCarRequest/DirectorConfirm',
      groupDirectorConfirm: '/DurableArticleCarRequest/GroupDirectorConfirm',
      leaderReject: '/DurableArticleCarRequest/LeaderReject',
      directorReject: '/DurableArticleCarRequest/DirectorReject',
      groupDirectorReject: '/DurableArticleCarRequest/GroupDirectorReject',

      proposerConfirm: '/DurableArticleCarRequest/ProposerConfirm',
      proposerReject: '/DurableArticleCarRequest/ProposerReject',
      driverUpdateListControl: '/DurableArticleCarRequest/DriverUpdateListControl',
      cancelConfirm: '/DurableArticleCarRequest/CancelConfirm',

      useCarList: '/DurableArticleCarRequest/UseCarList',

      useFuelList: '/DurableArticleCarRequest/UseFuelList',
      useFuelById: '/DurableArticleCarRequest/UseFuelById',
      useFuelUpdateById: '/DurableArticleCarRequest/UseFuelUpdateById',
      useFuelDelete: '/DurableArticleCarRequest/UseFuelDel',

      useCarOtherList: '/DurableArticleCarRequest/UseOtherList',

      getTravelingDetail: '/DurableArticleCarRequest/GetTravelingDetail',
      updateTravelingDetail: '/DurableArticleCarRequest/UpdateTravelingDetail',
      driverReturnCar: '/DurableArticleCarRequest/DriverReturnCar',
      checkerCheckCar: '/DurableArticleCarRequest/CheckerCheckCar',

      useCarGetDetail: '/DurableArticleCarRequest/UseCarGetDetail',
      useCarStartUpdate: '/DurableArticleCarRequest/UseCarStartUpdate',
      useCarReturnUpdate: '/DurableArticleCarRequest/UseCarReturnUpdate',
      useFuelUpdate: '/DurableArticleCarRequest/UseFuelUpdate',
      useCarOtherUpdate: '/DurableArticleCarRequest/UseCarOtherUpdate',
    },
    ReturnDepot: {
      GetAllMethodSell: '/Common/GetAllMethodSell',
      getlist: '/DurableArticleReturn/List',
      getlist2: '/DurableArticleTake/List',
      getlist3: '/DurableArticleSell/List',
      Listtab1: '/DurableArticleTreasury/List',
      TreasuryGetDetail: '/DurableArticleTreasury/GetDetail',
      TreasuryChangeItemOrg: '/DurableArticleTreasury/ChangeItemOrg',
      CartList: '/DurableArticleReturn/CartList',
      CartList2: '/DurableArticleTake/CartList',
      CartList3: '/DurableArticleSell/CartList',
      AddToCart: '/DurableArticleReturn/AddToCart',
      AddToCart2: '/DurableArticleTake/AddToCart',
      AddToCart3: '/DurableArticleSell/AddToCart',
      CartRemove: '/DurableArticleReturn/CartRemove',
      CartRemove2: '/DurableArticleTake/CartRemove',
      CartRemove3: '/DurableArticleSell/CartRemove',
      RemoveItem: '/DurableArticleReturn/RemoveItem',
      RemoveItem2: '/DurableArticleTake/RemoveItem',
      RemoveItem3: '/DurableArticleSell/RemoveItem',
      CartConfirm: '/DurableArticleReturn/CartConfirm',
      CartConfirm2: '/DurableArticleTake/CartConfirm',
      CartConfirm3: '/DurableArticleSell/CartConfirm',
      GetDetail: '/DurableArticleReturn/GetDetail',
      GetDetail2: '/DurableArticleTake/GetDetail',
      GetDetail3: '/DurableArticleSell/GetDetail',
      AddParts: '/DurableArticleReturn/AddParts',
      OfficerConfirm: '/DurableArticleReturn/OfficerConfirm',
      OfficerConfirm2: '/DurableArticleTake/OfficerConfirm',
      OfficerConfirm3: '/DurableArticleSell/OfficerConfirm',
      OfficerDraft: '/DurableArticleReturn/OfficerDraft',
      OfficerDraft2: '/DurableArticleTake/OfficerDraft',
      OfficerDraft3: '/DurableArticleSell/OfficerDraft',
      PLeaderConfirm: '/DurableArticleReturn/PLeaderConfirm',
      DirectorConfirm: '/DurableArticleReturn/DirectorConfirm',
      CentralTeamConfirm: '/DurableArticleReturn/CentralTeamConfirm',
      DirectorCentralTeamConfirm:
        '/DurableArticleReturn/DirectorCentralTeamConfirm',
      PLeaderReject: '/DurableArticleReturn/PLeaderReject',
      DirectorReject: '/DurableArticleReturn/DirectorReject',
      CentralTeamReject: '/DurableArticleReturn/CentralTeamReject',
      DirectorCentralTeamReject:
        '/DurableArticleReturn/DirectorCentralTeamReject',
      DirectorTreasuryConfirm: '/DurableArticleReturn/DirectorTreasuryConfirm',
      PLeaderConfirmTake: '/DurableArticleTake/PLeaderConfirm',
      PLeaderRejectTake: '/DurableArticleTake/PLeaderReject',
      DirectorConfirmTake: '/DurableArticleTake/DirectorConfirm',
      DirectorRejectTake: '/DurableArticleTake/DirectorReject',
      //type1
      CentralTeamConfirmTake: '/DurableArticleTake/CentralTeamConfirm',
      DirectorCentralConfirmTake:
        '/DurableArticleTake/DirectorCentralTeamConfirm',
      DirectorTreasuryConfirmTake:
        '/DurableArticleTake/DirectorTreasuryConfirm',
      CentralTeamRejectTake: '/DurableArticleTake/CentralTeamReject',
      DirectorCentralTeamRejectTake:
        '/DurableArticleTake/DirectorCentralTeamReject',
      DirectorTreasuryRejectTake: '/DurableArticleTake/DirectorTreasuryReject',
      //type2
      OPOfficerConfirmTake: '/DurableArticleTake/OPOfficerConfirm',
      OPLeaderConfirmTake: '/DurableArticleTake/OPLeaderConfirm',
      ODirectorConfirmTake: '/DurableArticleTake/ODirectorConfirm',
      OPOfficerRejectTake: '/DurableArticleTake/OPOfficerReject',
      OPLeaderRejectTake: '/DurableArticleTake/OPLeaderReject',
      ODirectorRejectTake: '/DurableArticleTake/ODirectorReject',
      POfficerReceiveTake: '/DurableArticleTake/POfficerReceive',
      POfficerPaidTake: '/DurableArticleTake/POfficerPaid',
      CPOfficerReceive: '/DurableArticleTake/CPOfficerReceive',
      CentralTeamPaid: '/DurableArticleTake/CentralTeamPaid',
      CentralTeamGFDraft: '/DurableArticleTake/CentralTeamGFDraft',
      CentralTeamGFConfirm: '/DurableArticleTake/CentralTeamGFConfirm',
      DirectorCentralTeamGFDraft:
        '/DurableArticleTake/DirectorCentralTeamGFDraft',
      DirectorCentralTeamGFConfirm:
        '/DurableArticleTake/DirectorCentralTeamGFConfirm',
      ReturnCancelConfirm: '/DurableArticleReturn/CancelConfirm',
      TakeCancelConfirm: '/DurableArticleTake/CancelConfirm',
      SellCancelConfirm: '/DurableArticleSell/CancelConfirm',
      // sell
      PLeaderConfirmSell: '/DurableArticleSell/LPLeaderConfirm',
      PLeaderRejectSell: '/DurableArticleSell/LPLeaderReject',
      DirectorConfirmSell: '/DurableArticleSell/LDirectorConfirm',
      DirectorRejectSell: '/DurableArticleSell/LDirectorReject',
      //type1
      CentralTeamConfirmSell: '/DurableArticleSell/CDirectorCentralTeamConfirm',
      DirectorCentralConfirmSell:
        '/DurableArticleSell/DirectorCentralTeamConfirm',
      DirectorTreasuryConfirmSell:
        '/DurableArticleSell/CDirectorTreasuryConfirm',
      CentralTeamRejectSell: '/DurableArticleSell/CentralTeamReject',
      DirectorCentralTeamRejectSell:
        '/DurableArticleSell/CDirectorCentralTeamReject',
      DirectorTreasuryRejectSell:
        '/DurableArticleSell/CDirectorCentralTeamReject',
      //type2
      LCentralTeamConfirm: '/DurableArticleSell/LCentralTeamConfirm',
      LDirectorCentralTeamConfirm: '/DurableArticleSell/LDirectorCentralTeamConfirm',
      ODirectorConfirmSell: '/DurableArticleSell/ODirectorConfirm',
      LCentralTeamReject: '/DurableArticleSell/LCentralTeamReject',
      LDirectorCentralTeamReject: '/DurableArticleSell/LDirectorCentralTeamReject',
      ODirectorRejectSell: '/DurableArticleSell/ODirectorReject',
    },
    annualCount: {
      getAnnualList: '/DurableArticleCount/List',
      getDetail: '/DurableArticleCount/GetDetail',
      createCount: '/DurableArticleCount/CreateCount',
      createCountDraft: '/DurableArticleCount/Draft',
      countReject: '/DurableArticleCount/Reject',
      saveCount: '/DurableArticleCount/SaveCount',
      confirmCount: '/DurableArticleCount/ConfirmCount',
      getAgencyCommittee: '/DurableArticleCount/GetAgencyCommittee',
      setAgencyCommittee: '/DurableArticleCount/SetAgencyCommittee',
      leaderConfirm: '/DurableArticleCount/LeaderConfirm',
      directorConfirm: '/DurableArticleCount/DirectorConfirm',
      directorTeamConfirm: '/DurableArticleCount/DirectorTeamConfirm',
      getCountItem: '/DurableArticleCount/GetCountItem',
      qrUpdate: '/DurableArticleCount/QrUpdate',
      countGetDetail: '/DurableArticleCount/CountGetDetail',
      cancelConfirm: '/DurableArticleCount/CancelConfirm',
      getRegistrationItems: '/DurableArticleCount/GetRegistrationItems',
      getRegistrationSaved: '/DurableArticleCount/GetRegistrationSaved',
      confirmation: '/DurableArticleCount/Confirmation',
      pOfficerGuarantee: '/DurableArticleCount/POfficerGuarantee',
      leaderGuarantee: '/DurableArticleCount/LeaderGuarantee',
      committeeSave: '/DurableArticleCount/CommitteeSave',
      committeeConfirm: '/DurableArticleCount/CommitteeConfirm',
      presidentCommitteeConfirm: '/DurableArticleCount/PresidentCommitteeConfirm',
      updateForm: '/DurableArticleCount/UpdateForm',
      updateCommittee: '/DurableArticleCount/UpdateCommittee',
      getSubDetail: '/DurableArticleRegistration/GetSubDetail',
    },
    annualAuditBuilding: {
      getBuildingInventoryList: '/BuildingInventoryCheck/InventoryCheckList',
      cancelCommittee: '/BuildingInventoryCheck/CanCelDraftCommittee',
      getRequestDocumentInventory:
        '/BuildingInventoryCheck/RequestDocumentNumber',
      getBuildingInventoryDetail:
        '/BuildingInventoryCheck/InventoryCheckDetail',
      addNewCommittee: '/BuildingInventoryCheck/AddCommittee',
      editNewCommittee: '/BuildingInventoryCheck/EditCommittee',
      committeeCountSaveDurable:
        '/BuildingInventoryCheck/MappingDurableArticles',
      committeeCountApprove: '/BuildingInventoryCheck/CommitteeApprove',
      assetDirectorAuditApprove: '/BuildingInventoryCheck/assetDirectorApprove',
      officerAuditApprove: '/BuildingInventoryCheck/SupplyManagerApprove',
      leaderOfficerAuditApprove: '/BuildingInventoryCheck/LeaderApprove',
      directorAuditApprove: '/BuildingInventoryCheck/DirectorApprove',

      regionLeaderOfficerAuditApprove:
        '/BuildingInventoryCheck/RegionLeaderApprove',
      regionDirectorAuditApprove:
        '/BuildingInventoryCheck/RegionDirectorApprove',
      editBuildingInventoryCheckInfo:
        '/BuildingInventoryCheck/EditDurableArticlesInventoryCheckInfo',
    },
    buildingInventoryReturn: {
      changeItemOrg: '/BuildingTreasury/ChangeItemOrg',
      getTreasuryDetail: '/BuildingTreasury/GetDetail',
      getCentralReturnList: '/BuildingTreasury/List',
      getBuildingReturnList: '/BuildingReturn/List',
      getBuildingReturnDetails: '/BuildingReturn/GetDetail',
      cancelConfirmRequest: '/BuildingReturn/CancelConfirm',
      officerBuildingReturnDraft: '/BuildingReturn/OfficerDraft',
      officerBuildingReturnConfirm: '/BuildingReturn/OfficerConfirm',
      pLeaderBuildingReturnReject: '/BuildingReturn/PLeaderReject',
      pLeaderBuildingReturnConfirm: '/BuildingReturn/PLeaderConfirm',
      directorBuildingReturnReject: '/BuildingReturn/DirectorReject',
      directorBuildingReturnConfirm: '/BuildingReturn/DirectorConfirm',
      centralBuildingReturnConfirm: '/BuildingReturn/CentralTeamConfirm',
      centralBuildingReturnReject: '/BuildingReturn/CentralTeamReject',
      directorCentralBuildingReturnConfirm:
        '/BuildingReturn/DirectorCentralTeamConfirm',
      directorCentralBuildingReturnReject:
        '/BuildingReturn/DirectorCentralTeamReject',
      directorCentralWareHouseBuildingReturnConfirm:
        '/BuildingReturn/DirectorTreasuryConfirm',
      directorCentralWareHouseBuildingReturnReject:
        '/BuildingReturn/DirectorCentralTeamReject',
    },
    buildingRegionalInventorySale: {
      getBdSellList: '/BuildingTreasury/SellList',

      getBuildingSaleList: '/BuildingSell/List',
      getBuildingSaleDetails: '/BuildingSell/GetDetail',
      officerBuildingSaleDraft: '/BuildingSell/OfficerDraft',
      officerBuildingSaleConfirm: '/BuildingSell/OfficerConfirm',
      pLeaderBuildingSaleReject: '/BuildingSell/LPLeaderReject',
      pLeaderBuildingSaleConfirm: '/BuildingSell/LPLeaderConfirm',
      directorBuildingSaleReject: '/BuildingSell/LDirectorReject',
      directorBuildingSaleConfirm: '/BuildingSell/LDirectorConfirm',
      centralBuildingSaleConfirm: '/BuildingSell/LCentralTeamConfirm',
      centralBuildingSaleReject: '/BuildingSell/LCentralTeamReject',
      directorCentralBuildingSaleConfirm:
        '/BuildingSell/LDirectorCentralTeamConfirm',
      directorCentralBuildingSaleReject:
        '/BuildingSell/LDirectorCentralTeamReject',
      cancelSellDraftRequest: '/BuildingSell/CancelConfirm',
    },
    buildingCentralInventorySale: {
      assetManagementDirector: '/BuildingSell/CDirectorCentralTeamReject',
      approveAssetDirector: '/BuildingSell/CDirectorCentralTeamConfirm',
      warehouseDirectorReject: '/BuildingSell/CDirectorStorageReject',
      approveWarehouseDirector: '/BuildingSell/CDirectorStorageConfirm',
    },
    buildingInventoryWithdrawal: {
      searchWidthDrawByOrgAndName: '/BuildingTreasury/TakeList',
      withdrawalList: '/BuildingTake/List',
      withdrawalDetails: '/BuildingTake/GetDetail',
      createWithdrawalDraft: '/BuildingTake/OfficerDraft',
      createNewWithdrawal: '/BuildingTake/OfficerConfirm',
      approveWithdrawalStep: '/BuildingTake/TakingConfirm',
      rejectWithdrawalStep: '/BuildingTake/TakingReject',
      canCelWithdrawalDraft: '/BuildingTake/CancelConfirm',
    },
    correctionRequest: {
      requestList: '/DataCorrection/List',
      cancelRequest: '/DataCorrection/Cancel',
      subjectList: '/DataCorrectionSubject/List',
      getDetail: '/DataCorrection/GetDetail',
      officerDraft: '/DataCorrection/OfficerDraft',
      officerConfirm: '/DataCorrection/OfficerConfirm',
      leaderConfirm: '/DataCorrection/LeaderConfirm',
      leaderReject: '/DataCorrection/LeaderReject',
      teamAccept: '/DataCorrection/TeamAccept',
      teamCheck: '/DataCorrection/TeamCheck',
      directorTeamCheck: '/DataCorrection/DirectorTeamCheck',

      agencyReportList: '/DataCorrection/AgencyReportList',
      subjectReportList: '/DataCorrection/SubjectReportList',
      allSubjectReportList: '/DataCorrection/AllSubjectReportList',
      allLocalSubjectReportList: '/DataCorrection/AllLocalSubjectReportList',
      allCentralSUbjectReportList:
        '/DataCorrection/AllCentralSubjectReportList',
    },
    updateApiVersion: {
      currentApiVersion: '/api/version',
    },
    materialReport: {
      materialAgencyReport: '/MaterialRegistration/GetMatarialRemainingByOrgReport',
      materialGroupWidthDrawReport: '/MaterialRegistration/GetMatarialPickUpSummaryByGroupReport',
      materialNotifyReport: '/MaterialRegistration/GetMatarialProcurementSummaryByFiscalYearReport',
    },
    materialDashboard: {
      materialDashboardApi: '/MaterialRegistration/GetMatarialDashBoard',
    },
    notification: {
      notificationDetail: '/Notification/GetDetail'
    },
    buildingCount: {
      getBuildingCountList: '/BuildingCount/GetBuildingCountList',
      createBuildingCount: '/BuildingCount/CreateBuildingCount',
      editBuildingCount: '/BuildingCount/EditBuildingCount',
      updateFileDocument: '/BuildingCount/UpdateFileDocument',
      updateCommittee: '/BuildingCount/UpdateCommittee',
      cancelBuildingCount: '/BuildingCount/CancelBuildingCount',
      getBuildingCountDetail: '/BuildingCount/GetBuildingCountDetail',
      getBuildingItemsByOrg: '/BuildingCount/GetBuildingItemsByOrg',
      getBuildingItemsByOrgSnapShot: '/BuildingCount/GetBuildingItemsByOrgSnapShot',
      committeeCount: '/BuildingCount/CommitteeCount',
      assetDirectorApprove: '/BuildingCount/AssetDirectorApprove',
      assetDirectorAcknowledged: '/BuildingCount/AssetDirectorAcknowledged',
      presidentCommitteeApprove: '/BuildingCount/PresidentCommitteeApprove',
      officerApprove: '/BuildingCount/OfficerApprove',
      leaderApprove: '/BuildingCount/LeaderApprove',
      leaderReject: '/BuildingCount/LeaderReject',
      assetDirectorReject: '/BuildingCount/AssetDirectorReject',
      getBuildingCountItemDetail: '/BuildingCount/GetBuildingCountItemDetail',
    },
  },

};
